// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bft_a bhs_wj bhs_ss bhs_xl"};